var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "trap-panel",
      attrs: { elevation: "1", "data-testid": "trap-panel" },
    },
    [
      _c(
        "v-tabs",
        {
          attrs: { grow: "" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("v-tab", { attrs: { "data-testid": "tab-trap-list" } }, [
            _vm._v(_vm._s(_vm.$t("tabs.trap_list"))),
          ]),
          _vm._v(" "),
          _c("v-tab", { attrs: { "data-testid": "tab-trap-ranking" } }, [
            _vm._v(_vm._s(_vm.$t("tabs.trap_ranking"))),
          ]),
          _vm._v(" "),
          _c("v-tab", { attrs: { "data-testid": "tab-insect-ranking" } }, [
            _vm._v(_vm._s(_vm.$t("tabs.insect_ranking"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          staticClass: "tabs-content",
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "v-tab-item",
            { staticClass: "pa-3" },
            [
              _c("floor-plan-item-list", {
                attrs: {
                  items: _vm.normalizedItems,
                  type: "trap",
                  "drag-data-key": "trapNo",
                },
                on: {
                  remove: function ($event) {
                    return _vm.$emit("remove", $event)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { staticClass: "pa-3" },
            [
              _c("floor-plan-item-ranking", {
                ref: "trapRanking",
                attrs: {
                  items: _vm.normalizedItems,
                  type: "trap",
                  "filter-label": _vm.insectFilterLabel,
                  "place-name": _vm.placeName,
                  "floor-plan-name": _vm.floorPlanName,
                  "selected-month": _vm.selectedMonth,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { staticClass: "pa-3" },
            [
              _c("insect-ranking", {
                ref: "insectRanking",
                attrs: {
                  traps: _vm.traps,
                  events: _vm.events,
                  "place-name": _vm.placeName,
                  "floor-plan-name": _vm.floorPlanName,
                  "selected-month": _vm.selectedMonth,
                  "is-exporting": _vm.exporting,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRankingTab
        ? _c("ranking-export-actions", {
            attrs: { exporting: _vm.exporting, disabled: !_vm.hasRankingData },
            on: {
              "export-image": _vm.handleExportImage,
              "export-csv": _vm.handleExportCsv,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }